import { createContext } from 'react';

import {
  FEATURE_FLAG_CONTEXT_DEFAULT,
  FeatureFlagContext as TFeatureFlagContext,
} from './FEATURE_FLAG_CONTEXT_DEFAULT';

export const FeatureFlagContext = createContext<TFeatureFlagContext>(FEATURE_FLAG_CONTEXT_DEFAULT);
